export default __webpack_public_path__ + "static/media/Montserrat-Thin.53139ad3.ttf";